/**
 * Модуль для анимаций Hero блока
 */

import { animateNumber } from '../utils/animations.js'
import { isElementInViewport } from '../utils/dom.js'
import { throttle } from '../utils/animations.js'

/**
 * Инициализирует анимации для Hero блока
 */
export function initHeroAnimations() {
  initHeroImageParallax()
  initHeroStatsAnimation()
  initHeroParallaxScroll()
}

/**
 * Инициализирует эффект параллакса для изображения Hero при наведении мыши
 */
function initHeroImageParallax() {
  const heroImage = document.querySelector('.hero-modern__img, .courses-hero__img')
  const heroWrapper = document.querySelector('.hero-modern__image-wrapper, .courses-hero__image-wrapper')

  if (!heroImage || !heroWrapper) return

  heroWrapper.addEventListener('mousemove', (e) => {
    // Останавливаем базовую анимацию при наведении мыши
    heroImage.style.animation = 'none'

    const bounds = heroWrapper.getBoundingClientRect()
    const mouseX = e.clientX - bounds.left
    const mouseY = e.clientY - bounds.top

    const centerX = bounds.width / 2
    const centerY = bounds.height / 2

    const rotateY = (mouseX - centerX) / 15
    const rotateX = (centerY - mouseY) / 15

    heroImage.style.transform = `perspective(1000px) rotateY(${rotateY}deg) rotateX(${rotateX}deg)`
  })

  // Возврат к базовой анимации при уходе мыши
  heroWrapper.addEventListener('mouseleave', () => {
    heroImage.style.animation = 'gentle-float 8s ease-in-out infinite'
    heroImage.style.transform = ''
  })
}

/**
 * Инициализирует анимацию чисел в блоке статистики Hero
 */
function initHeroStatsAnimation() {
  const statsNumbers = document.querySelectorAll('.hero-modern__stat-number, .courses-hero__stat-number')

  if (!statsNumbers.length) return

  function checkAndAnimateNumbers() {
    statsNumbers.forEach((number) => {
      if (!number.dataset.animated && isElementInViewport(number)) {
        animateNumber(number, 2000)
        number.dataset.animated = 'true'
      }
    })
  }

  // Запускаем проверку сразу при загрузке
  checkAndAnimateNumbers()

  // И при прокрутке страницы (с throttle для производительности)
  window.addEventListener('scroll', throttle(checkAndAnimateNumbers, 100))
}

/**
 * Инициализирует параллакс-анимацию при прокрутке
 */
function initHeroParallaxScroll() {
  const heroSection = document.querySelector('.hero-modern, .courses-hero')
  if (!heroSection) return

  const parallaxHandler = throttle(() => {
    const scrollPosition = window.scrollY
    const heroHeight = heroSection.offsetHeight
    const scrollPercentage = Math.min(scrollPosition / heroHeight, 1)

    // Параллакс для заголовка и контента
    const content = heroSection.querySelector('.hero-modern__content, .courses-hero__content')
    if (content) {
      content.style.transform = `translateY(${scrollPercentage * 50}px)`
    }

    // Параллакс для изображения (движется с другой скоростью)
    const image = heroSection.querySelector('.hero-modern__image, .courses-hero__image')
    if (image) {
      image.style.transform = `translateY(${scrollPercentage * 80}px)`
    }
  }, 16) // ~60fps

  window.addEventListener('scroll', parallaxHandler)
}




